<img src="assets/mockup/{{category}}_savings.svg" alt="">